import { AddType, DataSource, Label, Layout, LayoutProps, Table, TableCellProps, TableColumn, TableProps, TableRow, TableRowDisplayEvent } from "@mcleod/components";
import { ArrayUtil, ModelRow } from "@mcleod/core";

export enum ImportFileResultTableType {
    EDIT = "edit",
    POST = "post"
}

export class ImportFileResultTable extends Layout {
    private cellWidth: number;
    private ds: DataSource;
    private table: Table;
    private type: ImportFileResultTableType;

    constructor(type: ImportFileResultTableType, results: string[][], cellWidth?: number, props?: Partial<LayoutProps>) {
        const id = `${props?.id ?? "importFileResultTable"}-${type}`
        super( { ...props, needsServerLayout: false, id});
        this.type = type;
        this.cellWidth = cellWidth ?? 250;
        this.ds = new DataSource();
        const columnDescrs = ArrayUtil.getFirstElement(results);
        const rowData = results.slice(1);
        this.addTable(columnDescrs);
        this.loadData(columnDescrs, rowData);
    }

    public get tabCaption(): string {
        switch (this.type) {
            case ImportFileResultTableType.EDIT:
                return "Edit List";
            case ImportFileResultTableType.POST:
                return "Imported Records";
            default:
                return "";
        }
    }

    private get tableProps(): Partial<TableProps> {
        return {
            id: "tableResults",
            headerVisible: false,
            addType: AddType.NORMAL,
            allowEdit: false,
            allowDelete: false,
            fillRow: true,
            fillHeight: true,
            minHeight: "400px",
            rowBreak: false,
            emptyCaptionAfterSearch: "No results",
            emptyCaptionBeforeSearch: "No results",
            dataSource: this.ds
        };
    }

    protected addTable(columnDescrs: string[]) {
        if (ArrayUtil.isEmptyArray(columnDescrs)) {
            return;
        }
        this.table = new Table(this.tableProps);
        let columnIndex = -1;
        columnDescrs.forEach(columnDescr => {
            columnIndex++;
            const column = new TableColumn({
                id: `column${columnIndex}`,
                index: columnIndex,
                headingDef: {
                    caption: columnDescr,
                    width: this.cellWidth
                },
                cell: () => this.createValueCell(columnDescr)
            });
            this.table.addColumn(column, columnIndex == 0, columnIndex == (columnDescrs.length-1));
        });
        this.add(this.table);
    }

    private createValueCell(columnDescr: string): Partial<TableCellProps> {
        const valueLabel = new Label({
            field: columnDescr,
            id: "valueLabel",
            fillRow: true
        });
        return {
            components: [ valueLabel ],
            width: this.cellWidth
        }
    }

    private loadData(columnDescrs: string[], rowData: string[][]) {
        if (ArrayUtil.isEmptyArray(columnDescrs) ||
            ArrayUtil.isEmptyArray(rowData)) {
            return;
        }
        const dsData: ModelRow[] = [];
        rowData.forEach(rowData => {
            const modelRow = this.createModelRow(columnDescrs, rowData);
            dsData.push(modelRow);
        });
        this.ds.data = dsData;
        this.ds.displayDataInBoundComponents();
    }

    private createModelRow(columnDescrs: string[], rowData: string[]): ModelRow {
        const modelRow = new ModelRow("", false);
        for (let x=0; x < columnDescrs.length && x < rowData.length; x++) {
            modelRow.set(columnDescrs[x], rowData[x]);
        }
        return modelRow;
    }
}
